export enum GebruikersRol {
  Beheerder = 1,
  Visiteur = 2,
  Hoofd = 3,
  Medewerker = 4
}
